import { Baby, Footprints, Ruler, Shirt, Sparkles } from 'lucide-react';
import { CATEGORIES } from '../../data/categories';

const ICONS = {
  footprints: Footprints,
  shirt: Shirt,
  sparkles: Sparkles,
  ruler: Ruler,
  baby: Baby,
};

export default function CategorySelector({ value, onChange, label }) {
  return (
    <div>
      <label className="block text-sm font-medium text-slate-300 mb-2">{label}</label>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2">
        {CATEGORIES.map((cat) => {
          const Icon = ICONS[cat.icon] || Shirt;
          const active = value === cat.id;
          return (
            <button
              key={cat.id}
              type="button"
              onClick={() => onChange(cat.id)}
              className={`rounded-xl px-3 py-3 text-sm font-medium transition-all border flex flex-col items-center gap-1.5 ${
                active
                  ? 'bg-emerald-600 border-emerald-400 text-white shadow-lg shadow-emerald-900/30 scale-[1.02]'
                  : 'bg-slate-800 border-slate-700 text-slate-200 hover:border-emerald-600/50 hover:bg-slate-750'
              }`}
            >
              <Icon className={`w-5 h-5 ${active ? 'text-white' : 'text-emerald-500/80'}`} />
              <span className="leading-tight text-center">{cat.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
